export var hostSystemScenario={DMC:'DMC',EXPERT:'Expert'};